export default "__VITE_ASSET__34aaeea8__"